import { HELP_ICON_HTML } from '../../tourUi'

const FORM_READY_SELECTOR = '[data-tour="monitorado-form-root"][data-carregado="true"]'
const MODAL_SETTLE_MS = 350

const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds))

const isOnFormPage = () => /\/monitorado\/novo\/?$/.test(window.location.pathname)

const hasMonitoradosNaLista = () => document.querySelectorAll('[data-tour="monitorado-lista"] tbody tr').length > 0

let handoffEditarMonitoradoHandler = null

const bindHandoffAoEditarMonitorado = (tourManager) => {
    if (handoffEditarMonitoradoHandler) return

    handoffEditarMonitoradoHandler = (event) => {
        if (event.target.closest('input[type="checkbox"]')) return

        setTimeout(() => {
            if (!/\/monitorado\/\d+\/editar/.test(window.location.pathname)) return
            if (tourManager.activeTourName !== 'novo-monitorado') return

            unbindHandoffAoEditarMonitorado()
            tourManager.handoff('novo-monitorado', 'editar-monitorado', FORM_READY_SELECTOR)
        }, 100)
    }

    document.addEventListener('click', handoffEditarMonitoradoHandler, true)
}

const unbindHandoffAoEditarMonitorado = () => {
    if (!handoffEditarMonitoradoHandler) return

    document.removeEventListener('click', handoffEditarMonitoradoHandler, true)
    handoffEditarMonitoradoHandler = null
}

const mostrarAviso = (message, options = {}) => {
    document.dispatchEvent(new CustomEvent('showAviso', {
        detail: {
            message,
            callback: options.callback ?? null,
            callbackClose: options.callbackClose ?? null,
            callbackLabelClose: options.callbackLabelClose ?? 'Fechar',
            callbackLabel: options.callbackLabel ?? 'Continuar',
        },
    }))
}

const isFormularioPreenchido = () => {
    const root = document.querySelector('[data-tour="monitorado-form-root"]')
    if (!root) return false
    if (root.getAttribute('data-form-preenchido') === 'true') return true

    const nome = document.querySelector('#nome')?.value?.trim()
    const endereco = document.querySelector('#address')?.value?.trim()

    return Boolean(nome || endereco)
}

const AVISO_SALVAR_MONITORADO =
    'Os dados preenchidos durante o tour serão <b>salvos</b> como um novo monitorado.'

const salvarMonitorado = () => {
    document.querySelector('[data-tour="monitorado-salvar"]')?.click()
}

const aguardarAvisoDeSucesso = (tourManager) =>
    tourManager.waitForElement(() => {
        const body = document.querySelector('.modal.show .modal-body')

        if (body && /sucesso/i.test(body.textContent || '')) return body

        return null
    }, 8000)

const fecharModalTipo = async () => {
    const closeButton = document.querySelector('.modal.show .close')
    closeButton?.click()
    await delay(MODAL_SETTLE_MS)
}

const abrirModalTipo = async (tourManager) => {
    if (!document.querySelector('[data-tour="monitorado-tipo-descricao"]')) {
        document.querySelector('[data-tour="monitorado-tipo-novo"]')?.click()
    }

    await tourManager.waitForElement('[data-tour="monitorado-tipo-descricao"]')
    await delay(MODAL_SETTLE_MS)
}

const ensureModalTipoAberto = (tourManager) => () => abrirModalTipo(tourManager)

const bindIrParaClienteLink = (tourManager) => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-ir-cliente]'
        )

        if (!link || link._hdvIrClienteBound) return

        link._hdvIrClienteBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            tourManager.finish('novo-monitorado')
            tourManager.history?.push('/cliente')
        })
    }, 0)
}

const bindIrParaIntrodutorioLink = (tourManager) => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-start-tour="introdutorio"]'
        )

        if (!link || link._hdvIrIntrodutorioBound) return

        link._hdvIrIntrodutorioBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            tourManager.finish('novo-monitorado')
            tourManager.start('introdutorio', { resumeIndex: 0 })
        })
    }, 0)
}

const INTRO_DESCRIPTION = 'O Monitorado representa o ponto que será monitorado pela plataforma. Para criá-lo, é necessário ter um <strong>Cliente</strong> cadastrado e um <strong>Equipamento</strong> parametrizado.<br>Se precisar relembrar as etapas anteriores, <a href="#" class="hdv-tour-start-link" data-hdv-start-tour="introdutorio">inicie o guia introdutório</a>.'

const buildIntroStep = (tourManager, { onPrevClick } = {}) => ({
    popover: {
        title: 'Cadastro de Monitorado',
        description: INTRO_DESCRIPTION,
        ...(onPrevClick ? { onPrevClick } : {}),
    },
    onHighlighted: () => bindIrParaIntrodutorioLink(tourManager),
})

const salvarMonitoradoEEncerrar = (tourManager) => {
    salvarMonitorado()

    aguardarAvisoDeSucesso(tourManager)
        .then(() => {
            document.querySelector('.modal.show .modal-footer .hdv-btn-blue')?.click()
        })
        .catch(() => {})
}

const buildMonitoradoAntesSalvarTourSteps = (tourManager) => [
    {
        popover: {
            title: 'Antes de salvar',
            description: `Ao salvar, as abas de <strong>Parâmetros</strong>, <strong>Condições</strong>, <strong>Comandos</strong> e <strong>Fotos</strong> serão liberadas.<br><br> Edite esse monitorado e use o ícone de <strong>Ajuda</strong> ${HELP_ICON_HTML} para o guia dessas abas.`,
            onDoneClick: () => {
                tourManager.finish('monitorado-antes-salvar')
                mostrarAviso(AVISO_SALVAR_MONITORADO, {
                    callback: () => salvarMonitoradoEEncerrar(tourManager),
                    callbackLabelClose: 'Cancelar',
                })
            },
        },
    },
]

const concluirTour = (tourManager) => () => {
    tourManager.finish('novo-monitorado')

    if (!isFormularioPreenchido()) return

    tourManager.start('monitorado-antes-salvar', { resumeIndex: 0 })
}

const buildFormFieldSteps = (tourManager, { indiceNovoStep = null } = {}) => [
    {
        element: '[data-tour="monitorado-nome"]',
        ensureReady: () => tourManager.waitForElement(FORM_READY_SELECTOR),
        popover: {
            title: 'Nome do Monitorado',
            description: 'Dê um nome fácil de reconhecer. É assim que ele aparece na lista, no mapa e nas telas de monitoramento.',
            side: 'bottom',
            align: 'start',
            onPrevClick: () => {
                if (Number.isInteger(indiceNovoStep)) {
                    tourManager.navigateAndWait('/monitorado', '[data-tour="monitorado-novo"]', indiceNovoStep)
                        .then(() => tourManager.moveTo(indiceNovoStep))
                        .catch(() => {})
                    return
                }

                tourManager.movePrevious()
            },
        },
    },
    {
        element: '[data-tour="monitorado-cliente"]',
        popover: {
            title: 'Cliente',
            description: 'Selecione o cliente responsável por este monitorado. Caso você ainda não tenha um cliente cadastrado, <a href="#" class="hdv-tour-start-link" data-hdv-ir-cliente>clique aqui</a>.',
            side: 'bottom',
            align: 'start',
        },
        onHighlighted: () => bindIrParaClienteLink(tourManager),
    },
    {
        element: '[data-tour="monitorado-tipo"]',
        popover: {
            title: 'Tipo',
            description: 'O tipo organiza o monitorado e define o ícone e a cor no mapa. Escolha um existente ou crie um novo no botão ao lado.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="monitorado-tipo-novo"]',
        popover: {
            title: 'Novo tipo',
            description: 'Use este botão para cadastrar um tipo personalizado. Clique em <strong>Próximo</strong> para abrir o formulário de tipos.',
            side: 'left',
            align: 'start',
            onNextClick: () => {
                abrirModalTipo(tourManager)
                    .then(() => tourManager.moveNext())
                    .catch(() => tourManager.moveNext())
            },
        },
    },
    {
        element: '[data-tour="monitorado-tipo-descricao"]',
        ensureReady: ensureModalTipoAberto(tourManager),
        popover: {
            title: 'Descrição do Tipo',
            description: 'Informe o nome do tipo, por exemplo “Poço”, “Estação” ou “Reservatório”.',
            side: 'bottom',
            align: 'start',
            onPrevClick: () => {
                fecharModalTipo().then(() => tourManager.movePrevious())
            },
        },
    },
    {
        element: '[data-tour="monitorado-tipo-icone"]',
        ensureReady: ensureModalTipoAberto(tourManager),
        popover: {
            title: 'Ícone no mapa',
            description: 'Escolha o ícone que representa este tipo no mapa. Ao clicar, o guia será minimizado para você selecionar.',
            side: 'bottom',
            align: 'start',
            onPrevClick: () => tourManager.movePrevious(),
        },
        onHighlighted: (element) => {
            element?.addEventListener('click', () => tourManager.minimize(), { once: true })
        },
    },
    {
        element: '[data-tour="monitorado-tipo-cor"]',
        ensureReady: ensureModalTipoAberto(tourManager),
        popover: {
            title: 'Cor no mapa',
            description: 'Defina a cor do marcador no mapa para identificar rapidamente este tipo.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: () =>
            document.querySelector('[data-tour="monitorado-tipo-lista"]') ||
            document.querySelector('[data-tour="monitorado-tipo-lista-vazia"]') ||
            document.querySelector('[data-tour="monitorado-tipo-adicionar"]'),
        ensureReady: ensureModalTipoAberto(tourManager),
        popover: {
            title: 'Tipos cadastrados',
            description: 'Aqui ficam os tipos já criados. Você pode editar ou remover quando precisar.',
            side: 'top',
            align: 'start',
        },
    },
    {
        element: '[data-tour="monitorado-tipo-adicionar"]',
        ensureReady: ensureModalTipoAberto(tourManager),
        popover: {
            title: 'Adicionar tipo',
            description: 'Depois de preencher, clique em <strong>Adicionar</strong> para salvar o tipo. Em seguida, selecione-o no campo Tipo do formulário.',
            side: 'left',
            align: 'start',
            onNextClick: () => {
                fecharModalTipo().then(() => tourManager.moveNext())
            },
            onPrevClick: () => tourManager.movePrevious(),
        },
    },
    {
        element: '[data-tour="monitorado-endereco"]',
        popover: {
            title: 'Endereço / ponto no mapa',
            description: 'Digite o endereço. O sistema tenta localizar no mapa automaticamente. Se não encontrar, posicione o marcador manualmente.',
            side: 'bottom',
            align: 'start',
            onPrevClick: () => {
                abrirModalTipo(tourManager)
                    .then(() => tourManager.movePrevious())
                    .catch(() => tourManager.movePrevious())
            },
        },
    },
    {
        element: '[data-tour="monitorado-mapa"]',
        popover: {
            title: 'Mapa',
            description: 'Clique no mapa ou arraste o marcador para ajustar a localização exata do monitorado.',
            side: 'top',
            align: 'center',
        },
    },
    {
        element: '[data-tour="tab-monitorado-parametros"], [data-tour="tab-monitorado-condicoes"]',
        popover: {
            title: 'Outras abas',
            description: 'Parâmetros, Condições, Comandos e Fotos ficam disponíveis somente depois de salvar o monitorado pela primeira vez.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="monitorado-salvar"]',
        popover: {
            title: 'Salvar',
            description: 'Preencha os campos obrigatórios e salve. Depois disso, você poderá vincular parâmetros e comandos editando este monitorado.',
            side: 'top',
            align: 'start',
        },
    },
    {
        popover: {
            title: 'Tudo pronto!',
            description: `Após preencher os dados e salvar, recomendamos editar este monitorado para vincular os parâmetros. Clique em <strong>Ajuda</strong> ${HELP_ICON_HTML} na edição para o guia de como vincular parâmetros e comandos existentes.`,
            onDoneClick: concluirTour(tourManager),
        },
    },
]

const buildNovoMonitoradoTourSteps = (tourManager) => {
    const onForm = isOnFormPage()
    const steps = [buildIntroStep(tourManager)]
    let indiceNovoStep = null

    if (!onForm) {
        if (hasMonitoradosNaLista()) {
            steps.push({
                element: '[data-tour="monitorado-lista"]',
                popover: {
                    title: 'Monitorados cadastrados',
                    description: 'Aqui aparecem os monitorados já criados. Clique em um item da lista (ou use <strong>Editar</strong>) para abrir o guia das abas liberadas após o cadastro.',
                    side: 'top',
                    align: 'start',
                    onPrevClick: () => tourManager.movePrevious(),
                },
                onHighlighted: () => bindHandoffAoEditarMonitorado(tourManager),
            })
        }

        indiceNovoStep = steps.length
        const formStartIndex = indiceNovoStep + 1

        steps.push({
            element: '[data-tour="monitorado-novo"]',
            popover: {
                title: 'Novo monitorado',
                description: 'Para iniciar um novo cadastro, clique em <strong>Próximo</strong>. Vamos percorrer os dados principais desta tela.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    unbindHandoffAoEditarMonitorado()
                    tourManager.navigateAndWait('/monitorado/novo', FORM_READY_SELECTOR, formStartIndex)
                        .then(() => tourManager.moveTo(formStartIndex))
                        .catch(() => {})
                },
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: () => {
                if (window.location.pathname === '/monitorado' || window.location.pathname === '/monitorado/') {
                    bindHandoffAoEditarMonitorado(tourManager)
                }
            },
        })
    }

    tourManager.setTourCleanup?.(() => unbindHandoffAoEditarMonitorado())

    return [...steps, ...buildFormFieldSteps(tourManager, { indiceNovoStep })]
}

export { buildMonitoradoAntesSalvarTourSteps }
export default buildNovoMonitoradoTourSteps
